/** Courier task types as returned by the API. */
export const COURIER_TASK_TYPE = {
  PAYMENT: 1,
  RETURN: 3,
} as const;

/** Query params for `/courier-task/index`. */
export interface CourierTaskListParams {
  page?: number;
  per_page?: number;
  status?: number;
  courier_id?: number;
}

/** List item as returned by `/courier-task/index`. */
export interface CourierTaskBase {
  id: number;
  type: number;
  type_name: string;
  courier_id: number;
  courier_name: string;
  task_date: string;
  status: number;
  status_name: string;
  created_at: string;
}

/** Payment task item (type = payment). May contain nested subtasks. */
export interface CourierTaskPaymentItem {
  id: number;
  parent_id: number | null;
  status: number;
  status_name: string;
  order_ext_id: string;
  amount: number;
  shop_name: string;
  shop_ext_id: string | null;
  shop_phone: string | null;
  subtasks?: CourierTaskPaymentItem[];
}

/** Return task item (type = return). */
export interface CourierTaskReturnItem {
  order_id: number;
  order_ext_id: string;
  order_item_id: number;
  product_id: number;
  product_name: string;
  quantity: number;
  price: number;
  status: number;
  status_name: string;
  shop_name: string;
}

/** Detail as returned by `/courier-task/show?id=...&type=1` (payment). */
export interface CourierTaskPaymentDetail extends CourierTaskBase {
  items: CourierTaskPaymentItem[];
}

/** Detail as returned by `/courier-task/show?id=...&type=3` (return). */
export interface CourierTaskReturnDetail extends CourierTaskBase {
  items: CourierTaskReturnItem[];
}

export type CourierTaskDetail = CourierTaskPaymentDetail | CourierTaskReturnDetail;

/** Payload for `/courier-task/payment-accept`. */
export interface CourierTaskPaymentAcceptPayload {
  ids: number[];
}

/** Payload for `/courier-task/return-accept`. */
export interface CourierTaskReturnAcceptPayload {
  id: number;
  warehouse_id: number;
}
